import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const K = { fontFamily: "Kanit, Arial, sans-serif" };
const S = { fontFamily: "'Noto Serif', Georgia, serif" };

// Editorial article card: topic photo, category, title, short description. Whole card is one link.
export function ArticleCard({ post, eager = false, startHere = false, testId }) {
  return (
    <article data-testid={testId || `article-card-${post.slug}`} data-start-here={startHere ? "true" : "false"} className="min-w-0 h-full">
      <Link to={`/blog/${post.slug}`} className="group flex flex-col h-full focus:outline-none focus-visible:ring-2 focus-visible:ring-[#B3A17D] focus-visible:ring-offset-4 focus-visible:ring-offset-[#F5EFE7]">
        <div className="relative overflow-hidden aspect-[3/2] bg-[#451C25]/5">
          {post.cover_url && (
            <img src={post.cover_url} alt={post.cover_alt || ""} loading={eager ? "eager" : "lazy"} className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04] motion-reduce:transition-none motion-reduce:group-hover:scale-100" />
          )}
        </div>
        <p className="mt-5 text-[10px] tracking-[0.24em] uppercase text-[#897756]" style={K}>
          {post.category || "Guide"}{post.read_time ? ` · ${post.read_time}` : ""}{startHere ? <span className="ml-2 text-[#451C25]">· Start here</span> : null}
        </p>
        <h3 className="mt-3 text-xl md:text-[22px] leading-snug tracking-tight group-hover:text-[#6B4954] transition-colors" style={{ ...K, fontWeight: 500 }}>{post.title}</h3>
        {post.excerpt && <p className="mt-3 text-[#6B4954] text-[15px] leading-relaxed flex-1" style={S}>{post.excerpt}</p>}
        <span className="mt-4 inline-flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-[#451C25] font-semibold" style={K}>
          <span className="relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-full after:bg-[#B3A17D] after:origin-left after:transition-transform after:duration-300 group-hover:after:scale-x-100 after:scale-x-[0.35] motion-reduce:after:transition-none">Read</span>
          <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1 motion-reduce:transition-none" aria-hidden="true" />
        </span>
      </Link>
    </article>
  );
}

export default ArticleCard;
